export default class VirtualDevice implements IVirtualDevice
{
  deviceID: string;
}
